function MemberDetail(data) {
  return <h1>MemberDetail</h1>;
}

export default MemberDetail;
